import { DeviceEventConfig } from '@/api/site';
import { trim } from '@/libs/utils';

export default {
  data() {
    return {
      // 站点编辑搜索
      deviceConfigSearch: {
        date: null,
        keyword: '',
      },
      deviceConfigSearchDate: null,

      // 站点编辑数据
      deviceConfigData: null,

      // 分页
      deviceConfigPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },

      // 站点编辑表头
      deviceConfigColumns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          width: 60,
          dataIndex: 'id',
        },
        {
          title: this.$t('device_table_name'),
          dataIndex: 'devName',
        },
        {
          title: this.$t('com_table_data'),
          dataIndex: 'executeData',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('site_table_user'),
          dataIndex: 'executeUser',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
          scopedSlots: { customRender: 'hostIp' },
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('logs_table_execute_start_time'),
          dataIndex: 'executeStartTime',
          scopedSlots: { customRender: 'executeStartTime' },
          sorter: true,
        },

        {
          title: this.$t('logs_table_execute_end_time'),
          dataIndex: 'executeEndTime',
          scopedSlots: { customRender: 'executeEndTime' },
        },

        {
          title: this.$t('logs_table_execute_end_result'),
          dataIndex: 'executeResult',
          scopedSlots: { customRender: 'executeResult' },
        },
      ],
      tableLoading: false,
    };
  },

  methods: {
    // date picker change
    deviceConfigDateChange(value) {
      this.deviceConfigPagination.current = 1;
      if (value && value.length === 2) {
        const _startDate = value[0].startOf('day').valueOf();
        const _endData = value[1].endOf('day').valueOf();
        this.deviceConfigSearch.date = `${_startDate}-${_endData}`;
      } else {
        this.deviceConfigSearch.date = undefined;
      }

      this.getDeviceConfigData();
    },

    // 获取站点编辑数据
    getDeviceConfigData() {
      this.tableLoading = true;

      const params = {
        // 默认为1，即倒序
        orderType: 1,
        ...this.deviceConfigSearch,
        pageSize: this.deviceConfigPagination.pageSize,
        pageNo: this.deviceConfigPagination.current,
        stationId: this.stationId,
      };

      // 去掉空格
      if (params.keyword) {
        params.keyword = trim(params.keyword);
      }

      DeviceEventConfig(params)
        .then(res => {
          if (res.code === 0) {
            this.deviceConfigData = res.data;
            this.deviceConfigPagination.total = res.totalCount;
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    // reset
    resetDeviceConfigSearch() {
      this.deviceConfigPagination.current = 1;
      this.deviceConfigSearchDate = null;
      this.deviceConfigSearch = {
        startDate: null,
        endDate: null,
        name: '',
      };

      this.getDeviceConfigData();
    },

    // page change
    deviceConfigPageChange(page) {
      this.deviceConfigPagination.current = page;
      this.getDeviceConfigData();
    },

    // 表格排序
    handleDeviceConfigTableChange(pagination, filters, sorter) {
      const { field, order } = sorter;
      // orderField:"排序字段，0表示默认按主键，1按操作类型， 2按执行人，3按执行时间",
      // orderType:"排序类型, 0为升序，1为倒序",
      if (field === 'id') {
        this.deviceConfigSearch.orderField = 0;
      } else if (field === 'updateType') {
        this.deviceConfigSearch.orderField = 1;
      } else if (field === 'executeUser') {
        this.deviceConfigSearch.orderField = 2;
      } else if (field === 'executeStartTime') {
        this.deviceConfigSearch.orderField = 3;
      }
      this.deviceConfigSearch.orderType = order === 'ascend' ? 0 : 1;

      this.getDeviceConfigData();
    },
  },
};
